"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M8 11h3v10h2V11h3l-4-4zM4 3v2h16V3z"
}), 'VerticalAlignTopSharp');